<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="padding-top:150px;">Dedication</h1><br/>
<p style="font-family:Times New Roman;">This novel is dedicated to my family, particularly to Suzanne and our children, Annabel and Iain, and grandchildren, Matthew, James, Joshua and Kate.</p>
<p style="font-family:Times New Roman;">It is also dedicated to my extended Chinese ‘family’ of friends: Beibei, Changshun, Jing, Kungfeng, Liang, Ri, Sheng-Xun, Xiaoyu and Xinhua.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?3f283912